import {FC} from "react";
import {Button, Checkbox, Flex, Table, TableProps, Tooltip} from "antd";
import {Event} from '../../types/domain.ts';
import {EyeOutlined, ForwardOutlined, HomeOutlined} from "@ant-design/icons";
import {isAirportsEvent} from "../../utils/eventGuards.ts";
import dayjs from "dayjs";
import {EventNameCell} from "../EventNameCell/EventNameCell.tsx";
import {useNavigate} from "react-router";
import {EventActions} from "../EventActions/EventActions.tsx";

type Props = {
    events?: Event[];
    loading: boolean;
    onUpdate: VoidFunction;
}

export const EventsTable: FC<Props> = ({ events, loading, onUpdate }) => {
    const navigate = useNavigate();

    const columns: TableProps<Event>['columns'] = [
        {
            title: 'Тип',
            key: 'type',
            render: (_, event) => (
                <Tooltip title={isAirportsEvent(event) ? `Стаффинг аэропортов: ${event.category.name}` : 'Полет по маршруту'}>
                    {isAirportsEvent(event) ? <HomeOutlined /> : <ForwardOutlined />}
                </Tooltip>
            )
        },
        {
            title: 'Название',
            key: 'name',
            render: (_, event) => <EventNameCell event={event} />,
            minWidth: 300
        },
        {
            title: 'Дата',
            dataIndex: 'date',
            render: (date: string) => dayjs.utc(date).format('DD.MM.YYYY')
        },
        {
            title: 'Аэропорты',
            key: 'airports',
            render: (_, event) => (isAirportsEvent(event) ? event.airports : [...event.departures, ...event.arrivals]).map(({ airport }) => airport.name).join(', ')
        },
        {
            title: 'Отправлено на VATSIM',
            dataIndex: 'vatsim_published',
            render: (value: boolean) => <Checkbox disabled checked={value} />
        },
        {
            title: 'Действия',
            key: 'actions',
            render: (_, event) => (
                <Flex gap={8}>
                    <Button icon={<EyeOutlined />} onClick={() => navigate(`/events/${event.id}`)}>Посмотреть</Button>
                    <EventActions event={event} onUpdate={onUpdate} />
                </Flex>
            )
        }
    ]

    return (
        <Table
            columns={columns}
            dataSource={events}
            loading={loading}
            rowKey={(record) => record.id}
            scroll={{ x: true }}
            style={{ width: '100%' }}
        />
    )
}